import React from "react";
import Lottie from "react-lottie-player";

const EmojiDisplay = ({ selectedEmoji }) => {
    const completeRoutine = () => {
        console.log("completed");
    };

    return (
        <div className="selected-emoji">
            {selectedEmoji && (
                <div key={selectedEmoji}>
                    <Lottie
                        key={`lottie-${selectedEmoji.key}`}
                        path={`https://fonts.gstatic.com/s/e/notoemoji/latest/${selectedEmoji.key}/lottie.json`}
                        speed={1}
                        onComplete={completeRoutine}
                        play
                        style={{ width: "200px", height: "200px" }}
                    />
                </div>
            )}
        </div>
    );
};

export default EmojiDisplay;